export default __webpack_public_path__ + "static/media/french.a31d66ae.png";